import type { 
  ChatMessage, 
  UserMessage, 
  AssistantMessage 
} from '../types/domain';

// Message type guards
export const isUserMessage = (message: ChatMessage): message is UserMessage => {
  return message.sender === 'user';
};

export const isAssistantMessage = (message: ChatMessage): message is AssistantMessage => {
  return message.sender === 'assistant';
};

// Widget type guard
export const hasWidget = (message: ChatMessage): message is AssistantMessage & Required<Pick<AssistantMessage, 'widgetType' | 'widgetData'>> => {
  return (
    message.sender === 'assistant' &&
    'widgetType' in message &&
    'widgetData' in message &&
    message.widgetType !== undefined &&
    message.widgetData !== undefined
  );
};

// Response type guards
export const hasPanelSwitch = (message: AssistantMessage): boolean => {
  return !!message.targetPanelId;
};

// Utility functions
export const getMessagePreview = (message: ChatMessage, maxLength: number = 100): string => {
  const content = message.content.trim();
  return content.length > maxLength ? `${content.substring(0, maxLength - 3)}...` : content;
};

export const generateMessageId = (): string => {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
};

export const generateOptimisticSessionId = (): string => {
  return `optimistic-session-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
};

export const REASONING_LABELS: Record<string, string> = {
  routing: 'Routing',
  tool_use: 'Tools',
  responding: 'Responding',
  reasoning: 'Reasoning',
  planning: 'Planning',
  tool_selection: 'Tool Selection',
  critique: 'Critique',
  summary: 'Summary',
};
